var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2624",
    x: -256,
    y: -567,
    width: 600,
    height: 744,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 483022"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2184",
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#2A353D",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 483021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.9997 47.6667C68.9997 51.1667 67.833 54.0833 65.7797 56.1367C63.7497 58.1667 60.833 59.3333 57.333 59.3333V64.3033C57.333 66.17 55.2564 67.2901 53.7164 66.2634L43.333 59.3333H38.3864C38.573 58.6333 38.6663 57.91 38.6663 57.1633C38.6663 54.7833 37.7563 52.5901 36.263 50.9334C34.583 49.0201 32.0863 47.83 29.333 47.83C26.7197 47.83 24.3397 48.9034 22.6364 50.6534C22.4264 49.7201 22.333 48.7167 22.333 47.6667V33.6667C22.333 26.6667 26.9997 22 33.9997 22H57.333C64.333 22 68.9997 26.6667 68.9997 33.6667V47.6667Z",
    stroke: "#2A353D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.3867 59.3334C38.1767 60.2667 37.8034 61.1767 37.3134 61.9701C35.7034 64.6767 32.74 66.4967 29.3333 66.4967C26.93 66.4967 24.76 65.5867 23.1267 64.0933C22.4267 63.4867 21.82 62.7634 21.3533 61.9701C20.49 60.5701 20 58.9134 20 57.1634C20 54.6434 21.0033 52.3335 22.6367 50.6535C24.34 48.9035 26.72 47.8301 29.3333 47.8301C32.0867 47.8301 34.5833 49.0201 36.2633 50.9335C37.7567 52.5901 38.6667 54.7834 38.6667 57.1634C38.6667 57.9101 38.5733 58.6334 38.3867 59.3334Z",
    stroke: "#2A353D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.83 59.5898L26.8833 54.6665",
    stroke: "#2A353D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.7831 54.7363L26.8364 59.6596",
    stroke: "#2A353D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.5 40.8301H53.8333",
    stroke: "#2A353D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDescription);
export default __webpack_public_path__ + "static/media/no-description.1055767d1cf02546eec3db74ed34c006.svg";
export { ForwardRef as ReactComponent };